function Error404() {
  return <div>Error 404: Pagina fallo - Refresca la pagina</div>;
}

export default Error404;
